import { render } from "./feedDetail.vue?vue&type=template&id=45babf00&scoped=true"
import script from "./feedDetail.vue?vue&type=script&lang=js"
export * from "./feedDetail.vue?vue&type=script&lang=js"

import "./feedDetail.vue?vue&type=style&index=0&id=45babf00&scoped=true&lang=css"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45babf00"]])

export default __exports__